module.exports = __webpack_public_path__ + "img/40_38_034_850.e00f5aad.jpg";